// Totes On Time — Box Calculator
// Security: all output uses textContent. No external API calls. No eval. No innerHTML on user data.
(function () {
  'use strict';

  // Config — change these to tune recommendations
  // (kept here so non-devs can tweak without touching DOM logic)
  var BASE_TOTES = { studio: 20, '1bd': 35, '2bd': 50, '3bd': 75 };
  var DENSITY_MULT = { light: 0.85, normal: 1.0, heavy: 1.2 };
  var BUNDLE_PRICES = { studio: 129, '1bd': 189, '2bd': 239, '3bd': 299 };
  var BUNDLE_NAMES = { studio: 'Studio', '1bd': '1 Bedroom', '2bd': '2 Bedroom', '3bd': '3+ Bedroom' };
  var EXTRA_WEEK = { studio: 70, '1bd': 100, '2bd': 125, '3bd': 155 };
  var ADDON_LABELS = {
    kitchen: 'Dish-pack inserts',
    closet: 'Wardrobe boxes (×2)',
    books: 'Extra small totes (×5)',
    art: 'Framed-art protector pads'
  };

  function recommendBundle(toteCount) {
    if (toteCount <= 22) return 'studio';
    if (toteCount <= 38) return '1bd';
    if (toteCount <= 55) return '2bd';
    return '3bd';
  }

  function compute(state) {
    var size = state.size || 'studio';
    var density = state.density || 'normal';
    var extras = Array.isArray(state.extras) ? state.extras : [];
    var duration = parseInt(state.duration || '1', 10);
    if (isNaN(duration) || duration < 1) duration = 1;
    if (duration > 8) duration = 8;

    var base = BASE_TOTES[size] || 20;
    var totes = Math.round(base * (DENSITY_MULT[density] || 1));
    if (extras.indexOf('books') !== -1) totes += 3;

    var recommended = recommendBundle(totes);
    var basePrice = BUNDLE_PRICES[recommended] || 129;
    var weeklyExtra = EXTRA_WEEK[recommended] || 70;

    var price = basePrice + (Math.max(0, duration - 1) * weeklyExtra);
    if (extras.indexOf('kitchen') !== -1) price += 18;
    if (extras.indexOf('closet') !== -1) price += 24;
    if (extras.indexOf('art') !== -1) price += 12;

    var addonList = extras.map(function (e) { return ADDON_LABELS[e]; }).filter(Boolean);

    return {
      bundle: BUNDLE_NAMES[recommended] || 'Studio',
      totes: totes,
      addons: addonList.length ? addonList.join(', ') : 'None — just the bundle',
      price: price
    };
  }

  function init() {
    var calcs = document.querySelectorAll('[data-calc]');
    if (!calcs.length) return;

    calcs.forEach(function (calc) {
      var state = { size: null, density: null, extras: [], duration: null };
      var currentStep = 1;
      var maxSteps = 4;

      var steps = calc.querySelectorAll('.calc-step');
      var progressBar = calc.querySelector('[data-calc-progress]');
      var backBtn = calc.querySelector('[data-calc-back]');
      var stepIndicator = calc.querySelector('[data-step-indicator]');
      var restartBtn = calc.querySelector('[data-calc-restart]');

      function showStep(n) {
        steps.forEach(function (s) {
          s.removeAttribute('data-active');
          if (parseInt(s.getAttribute('data-step'), 10) === n) {
            s.setAttribute('data-active', 'true');
          }
        });
        if (progressBar) {
          var pct = Math.min(100, (n / (maxSteps + 1)) * 100);
          progressBar.style.width = pct + '%';
        }
        if (stepIndicator) {
          if (n <= maxSteps) {
            stepIndicator.textContent = n + ' / ' + maxSteps;
          } else {
            stepIndicator.textContent = 'Done!';
          }
        }
        if (backBtn) {
          if (n > 1 && n <= maxSteps + 1) {
            backBtn.hidden = false;
          } else {
            backBtn.hidden = true;
          }
        }
        currentStep = n;
      }

      function renderResult() {
        var result = compute(state);
        var bundleEl = calc.querySelector('[data-result-bundle]');
        var totesEl = calc.querySelector('[data-result-totes]');
        var addonsEl = calc.querySelector('[data-result-addons]');
        var priceEl = calc.querySelector('[data-result-price]');

        // textContent only — XSS-safe
        if (bundleEl) bundleEl.textContent = result.bundle;
        if (totesEl) totesEl.textContent = result.totes + ' totes';
        if (addonsEl) addonsEl.textContent = result.addons;
        if (priceEl) priceEl.textContent = String(result.price);
      }

      // Wire up option buttons
      var optionBlocks = calc.querySelectorAll('.calc-options');
      optionBlocks.forEach(function (block) {
        var field = block.getAttribute('data-field');
        var isMulti = block.classList.contains('calc-multi');
        var options = block.querySelectorAll('.calc-option');

        options.forEach(function (opt) {
          opt.addEventListener('click', function () {
            // Strict: only allow values from the data-value attribute (no user-typed input)
            var value = opt.getAttribute('data-value');
            if (typeof value !== 'string') return;

            if (isMulti) {
              // Toggle in array
              var idx = state[field].indexOf(value);
              if (idx === -1) {
                state[field].push(value);
                opt.setAttribute('data-selected', 'true');
              } else {
                state[field].splice(idx, 1);
                opt.removeAttribute('data-selected');
              }
              // Multi-select: don't auto-advance, show a Continue button
              if (!block.querySelector('.calc-continue')) {
                var cont = document.createElement('button');
                cont.type = 'button';
                cont.className = 'btn btn-primary calc-continue';
                cont.textContent = 'Continue →';
                cont.addEventListener('click', function () {
                  advance();
                });
                block.parentNode.appendChild(cont);
              }
            } else {
              state[field] = value;
              // Single-select: auto-advance after a short delay
              options.forEach(function (o) { o.removeAttribute('data-selected'); });
              opt.setAttribute('data-selected', 'true');
              setTimeout(advance, 250);
            }
          });
        });
      });

      function advance() {
        if (currentStep < maxSteps) {
          showStep(currentStep + 1);
        } else if (currentStep === maxSteps) {
          renderResult();
          showStep(maxSteps + 1);
        }
      }

      if (backBtn) {
        backBtn.addEventListener('click', function () {
          if (currentStep > 1) showStep(currentStep - 1);
        });
      }

      if (restartBtn) {
        restartBtn.addEventListener('click', function () {
          state = { size: null, density: null, extras: [], duration: null };
          calc.querySelectorAll('[data-selected]').forEach(function (el) {
            el.removeAttribute('data-selected');
          });
          showStep(1);
        });
      }

      // Init
      showStep(1);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
